import './index.css';
import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import BackendStatusBar from './components/BackendStatusBar';
import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './pages/login';
import ForgotPasswordPage from './pages/forgot-password';
import VendorLayout from './pages/vendor/VendorLayout';
import { userRoles } from './constants/userRoles';

function App() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <BackendStatusBar />
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute allowedRoles={[userRoles.vender]}>
              <VendorLayout />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
